ACC.refresh = {

  bindAll: function() {
    this.getCheckoutCartDataAndRefreshPage();

    $.extend({
      postJSON: function(url, data, callback) {
        return $.post(url, data, callback, 'json');
      }
    });

    $.blockUI.defaults.overlayCSS = {};
    $.blockUI.defaults.css = {};
  },

  refreshCartTotals: function(checkoutCartData) {
    $('#cart_totals_div').html($('#cartTotalsTemplate').tmpl(checkoutCartData));
  },

  refreshCartItems: function(checkoutCartData) {
    if ($('.ph-showAdditionalCost').text() === 'false' && $('.ph-checkATPEnabled').text() === 'false') {
      $('#cart_items_tbody').html($('#cartItemsTemplate').tmpl(checkoutCartData));
    }
  },

  refreshPaymentTypeSection: function(checkoutCartData) {
    var paymentTypeFromCart = checkoutCartData.paymentType.code;

    $('input:radio[name=\'PaymentType\'][value=' + paymentTypeFromCart + ']').attr('checked', true);
    $('input[name=\'PurchaseOrderNumber\']').attr('value', checkoutCartData.purchaseOrderNumber);
    $('input[name=\'deliveryAttention\']').attr('value', checkoutCartData.deliveryAttention);
    $('input[name=\'deliveryPhone\']').attr('value', checkoutCartData.deliveryPhone);

    ACC.paymenttype.setPaymentType();
    ACC.paymenttype.hideAndShowRequiredDivOneStore(paymentTypeFromCart);
    ACC.paymenttype.markPaymentTypeSectionAsCompleted(checkoutCartData);
    ACC.paymenttype.hideAndShowRequiredDiv(paymentTypeFromCart);
  },

  bindToPaymentTypeSelection: function() {
    $('input:radio[name=\'PaymentType\']').change(function() {
      ACC.paymenttype.setPaymentType();
    });
  },

  refreshPage: function(checkoutCartData) {
    // Update delivery address, delivery method and payment sections, and cart totals section
    ACC.address.refreshDeliveryAddressSection(checkoutCartData);
    ACC.deliverymode.refreshDeliveryMethodSection(checkoutCartData);
    ACC.paymentmethod.refreshPaymentDetailsSection(checkoutCartData);
    ACC.refresh.refreshPaymentTypeSection(checkoutCartData);
    ACC.refresh.refreshCartTotals(checkoutCartData);
    ACC.placeorder.updatePlaceOrderButton();
    ACC.negotiatequote.updateRequestQuoteButton();
  },

  getCheckoutCartDataAndRefreshPage: function() {
    var getCheckoutCartUrl = $.trim($('.getCheckoutCartUrl').html());

    if (getCheckoutCartUrl !== '' && getCheckoutCartUrl !== 'undefined') {
      $.ajaxSetup({
        cache: false
      });
      $.getJSON(getCheckoutCartUrl, function(checkoutCartData) {
        ACC.refresh.refreshPage(checkoutCartData);
        ACC.refresh.bindToPaymentTypeSelection();
      });
    }
  },
  submitSetDefault: function(id) {
    document.getElementById('setDefaultPaymentDetails' + id).submit();
  }
};

$(document).ready(function() {
  ACC.refresh.bindAll();
});

